import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill"]
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["fill"]
const _hoisted_5 = ["fill"]
const _hoisted_6 = ["fill"]

import { withDefaults } from 'vue';

interface IProps {
    color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyIcon',
  props: {
    color: null
  },
  setup(__props: any) {

const props = __props as { color?: string };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      opacity: "0.4",
      d: "M2.1001 22V6.03003C2.1001 4.02003 3.10015 3.01001 5.09015 3.01001H11.3201C13.3101 3.01001 14.3001 4.02003 14.3001 6.03003V22",
      fill: __props.color || '#7E8695'
    }, null, 8, _hoisted_2),
    _createElementVNode("path", {
      d: "M10.7501 9H5.80005C5.39005 9 5.05005 8.66 5.05005 8.25C5.05005 7.84 5.39005 7.5 5.80005 7.5H10.7501C11.1601 7.5 11.5001 7.84 11.5001 8.25C11.5001 8.66 11.1601 9 10.7501 9Z",
      fill: __props.color || '#7E8695'
    }, null, 8, _hoisted_3),
    _createElementVNode("path", {
      d: "M10.7501 12.75H5.80005C5.39005 12.75 5.05005 12.41 5.05005 12C5.05005 11.59 5.39005 11.25 5.80005 11.25H10.7501C11.1601 11.25 11.5001 11.59 11.5001 12C11.5001 12.41 11.1601 12.75 10.7501 12.75Z",
      fill: __props.color || '#7E8695'
    }, null, 8, _hoisted_4),
    _createElementVNode("path", {
      d: "M8.25 22.75C7.84 22.75 7.5 22.41 7.5 22V18.25C7.5 17.84 7.84 17.5 8.25 17.5C8.66 17.5 9 17.84 9 18.25V22C9 22.41 8.66 22.75 8.25 22.75Z",
      fill: __props.color || '#7E8695'
    }, null, 8, _hoisted_5),
    _createElementVNode("path", {
      d: "M23 21.25H20.73V18.25C21.68 17.94 22.37 17.05 22.37 16V14C22.37 12.69 21.3 11.62 19.99 11.62C18.68 11.62 17.61 12.69 17.61 14V16C17.61 17.04 18.29 17.92 19.22 18.24V21.25H1C0.59 21.25 0.25 21.59 0.25 22C0.25 22.41 0.59 22.75 1 22.75H19.93C19.95 22.75 19.96 22.76 19.98 22.76C20 22.76 20.01 22.75 20.03 22.75H23C23.41 22.75 23.75 22.41 23.75 22C23.75 21.59 23.41 21.25 23 21.25Z",
      fill: __props.color || '#7E8695'
    }, null, 8, _hoisted_6)
  ]))
}
}

})